import { escapeHtml } from './safeHtml';

// Crew roles (the `role` on a crew member's profile) and the kinds of card each one may draft.
// The database rules (firestore.rules: crewKindOk) enforce the same list.
export const CREW_ROLES = {
    ARTIST: { label: 'Artist', blurb: 'You make doors and objects.' },
    MUSICIAN: { label: 'Musician', blurb: 'You make sounds and music.' },
    WRITER: { label: 'Writer', blurb: 'You write the story cards.' },
    HELPER: { label: 'Helper', blurb: 'You scout places and help in the field.' },
};

// kind -> where the card is stored and how it is labelled
export const CARD_KINDS = {
    DOOR: { label: 'Door', col: 'artifacts', add: '+ Add a door' },
    OBJECT: { label: 'Object', col: 'artifacts', add: '+ Add an object' },
    SOUND: { label: 'Sound', col: 'artifacts', add: '+ Add a sound' },
    SCOUT: { label: 'Scouting find', col: 'artifacts', add: '+ Suggest a spot' },
    LORE: { label: 'Story card', col: 'ideas', add: '+ Add a story card' },
};

export const kindsForRole = (role) => ({
    ARTIST: ['DOOR', 'OBJECT'],
    MUSICIAN: ['SOUND'],
    WRITER: ['LORE'],
    HELPER: ['SCOUT', 'DOOR', 'OBJECT'],
}[role] || []);

// plain text <-> the simple HTML the rest of T3S stores in `desc`
export const textToHtml = (text) => String(text || '').trim()
    .split(/\n{2,}/)
    .map(p => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`)
    .join('');

export const htmlToText = (html) => String(html || '')
    .replace(/<\/p>\s*<p>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&')
    .trim();

export const STATUS_LABEL = (status) => (status === 'VERIFIED' ? 'Approved' : (status === 'DRAFT' || !status) ? 'In review' : status);
